import { app } from '@/main'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { ApolloClient } from 'apollo-client'
import { WebSocketLink } from 'apollo-link-ws'

export const getSocketClient = () => {
  const wsLink = new WebSocketLink({
    uri: app.$store.getters.socket_url,
    options: {
      reconnect: true,
      connectionParams: {}
    }
  })

  // wsLink.subscriptionClient.on('connecting', () => {
  //   console.log('connecting')
  // })

  // wsLink.subscriptionClient.on('connected', () => {
  //   console.log('connected')
  // })

  // wsLink.subscriptionClient.on('reconnecting', () => {
  //   console.log('reconnecting')
  // })

  // wsLink.subscriptionClient.on('reconnected', () => {
  //   console.log('reconnected')
  // })

  // wsLink.subscriptionClient.on('disconnected', () => {
  //   console.log('disconnected')
  // })

  // const link = split(
  //   ({ query }) => {
  //     const { kind, operation } = getMainDefinition(query)
  //     return kind === 'OperationDefinition' && operation === 'subscription'
  //   },
  //   wsLink,
  //   httpLink
  // )

  const apolloClient = new ApolloClient({
    link: wsLink,
    cache: new InMemoryCache(),
    connectToDevTools: true
  })

  return { apolloClient, subscriptionClient: wsLink.subscriptionClient }
}

export const subscribe = (apolloClient, gql, callback) => {
  apolloClient.subscribe({ query: gql }).subscribe({
    next: ({ data }) => {
      if (typeof callback === 'function') {
        callback(data)
      }
    },
    error(err) {
      console.error(err)
    }
  })
}

export const unSubscribeAll = subscriptionClient => {
  subscriptionClient.close()
}
